<template>
  <div>
    <send-email-modal/>
    <send-whatsapp-modal/>
    <print-warranty-modal/>
    <print-manufacture-modal/>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de orçamento"
      message="Tem certeza que deseja excluir esse orçamento?"/>
  </div>
</template>
<script>
import SendEmailModal from '_modules/quotation/components/modal/SendEmailModal.vue';
import QuotationDelete from '_modules/quotation/components/QuotationDelete';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import SendWhatsappModal from '_modules/quotation/components/modal/SendWhatsappModal.vue';
import PrintWarrantyModal from '_modules/quotation/components/modal/PrintWarrantyModal.vue';
import PrintManufactureModal from '_modules/quotation/components/modal/PrintManufactureModal.vue';

export default {
  name: 'common-include-modals',
  mixins: [QuotationDelete],
  components: {
    SendEmailModal,
    ConfirmationModal,
    SendWhatsappModal,
    PrintWarrantyModal,
    PrintManufactureModal,
  },
};
</script>

